import { render, staticRenderFns } from "./c-responsive-list.vue?vue&type=template&id=5ebbb5e6&scoped=true&"
import script from "./c-responsive-list.vue?vue&type=script&lang=js&"
export * from "./c-responsive-list.vue?vue&type=script&lang=js&"
import style0 from "./c-responsive-list.vue?vue&type=style&index=0&id=5ebbb5e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebbb5e6",
  null
  
)

export default component.exports